import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { imagesList_template } from "../components/templates/imagesList_template";
import { header } from "./header";
import { tags } from "./tags";

declare var ko: any;
declare var page: any;

export class images extends vnModule_knockoutJS {
    protected listTemplate: imagesList_template;
    protected pagination: pagination_template;
    protected timer: number;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdlCaller: string;
    protected viewPageUrl;

    protected getModuleName() {
        return "images";
    }

    public buildContent(): Array<Element> {
        this.listTemplate = new imagesList_template("list", this.viewModel, this);
        this.template = this.listTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Images List");

        return [this.listTemplate.build()];
    }

    public fillPage(): void {
        this.listTemplate.buildDatePickerCalendar();
        this.getData();
    }

    protected getData() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterList() {
        this.filterSimpleCancel();
        this.loadingIn(this.listTemplate.builtTemplate.children.namedItem("list-results"));
        this.timer = new Date().getTime();
        this.sendFilterCall(
            "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/images/get/",
            this.listTemplate.getViewModelForRequest(),
            this.onFilterList,
            XMLHttpRequestHandler_requestType.GET,
            "images",
            this.listTemplate.builtTemplate.children.namedItem("list-results"),
        );
    }

    protected onFilterList(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                //console.log(responseParsed);
                let imagesToSet = [];
                for (let item of responseParsed.paginatedImages.data) {
                    imagesToSet.push({
                        id: item.id,
                        name: item.name,
                        url: item.url,
                        dateCreated: item.dateCreated,
                        dateUpdated: item.dateUpdated,
                        tags: item.tags,
                    });
                }
                obj.listTemplate.setIdBrand(obj.getVnAppZone().app.params.idBrand);
                obj.listTemplate.setImages(imagesToSet);
                obj.listTemplate.setResultInfo(
                    responseParsed.paginatedImages.totalCount,
                    responseParsed.paginatedImages.totalPage,
                    Math.round(((new Date().getTime() - obj.timer) / 1000) * 100) / 100,
                );
                obj.viewModel.list.pagination.itemCount(responseParsed.paginatedImages.totalCount);
                obj.listTemplate.setRatios(responseParsed.ratios);
                obj.listTemplate.setOrientations(responseParsed.orientations);
                obj.listTemplate.setUploadSources(responseParsed.uploadSources, responseParsed.selectedUploadSource);
                obj.listTemplate.setIsEverettImportRunning(responseParsed.everettTaskRunning);
                obj.listTemplate.setShowEverettImport(responseParsed.showEverettImport);
                obj.updateViewModelFromPath();
                obj.getSearchPresets();
            });
            obj.loadingOut(obj.listTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected filterByUrl() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters) {
        this.listTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected filterDateOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(idElement) {
        switch (idElement) {
            case "filterTag":
                this.listTemplate.updateSelectedTags();
            break;
        default:
            this.viewModel.list.pagination.pageNumber(1);
            this.filterList();
            break;
        }
    }

    protected paginationOnPageClick() {
        if(this.viewModel.list.resultInfo && this.viewModel.list.resultInfo.nbr_results()){
            this.listTemplate.getTemplateViewModel().pagination.reuseTotalCount = this.viewModel.list.resultInfo.nbr_results();
        }
        this.listTemplate.onClickBulkEditCancel();
        this.listTemplate.getTemplateViewModel().toggleAll(false);
        this.listTemplate.getTemplateViewModel().isToggleAllChecked(false);
        this.filterList();
    }

    protected imagesListReorder() {
        this.filterList();
    }

    protected getMemoryViewModel() {
        let templateViewModel = this.listTemplate.getTemplateViewModel();
        delete templateViewModel.images;
        return templateViewModel;
    }

    protected addImage() {
        this.filterSimpleCancel();
        this.saveViewModule(this.getMemoryViewModel());
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/images/add");
    }

    protected viewImage(id) {
        this.saveViewModule(this.getMemoryViewModel());
        let viewUrl =
            window.location.origin + "/brand/" + this.getVnAppZone().app.params.idBrand + "/images/view/" + id;
        let editUrl =
            window.location.origin + "/brand/" + this.getVnAppZone().app.params.idBrand + "/images/edit/" + id;
        this.savePreviousPage(viewUrl, window.location.href);
        this.savePreviousPage(editUrl, window.location.href);
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/images/view/" + id);
    }

    protected getSearchPresets(): void {
        this.cancelRequest("getSearchPresets");
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        let usrReq_url: string = "/api/search_preset/get/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getSearchPresets"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getSearchPresets"].onReadyStateFunction = this.onGetSearchPresets;
        this.XHRHdls["getSearchPresets"].execute();
    }

    protected onGetSearchPresets(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.setSearchPresets(response);
                //obj.filterList();
            });
        };
    }

    protected saveSearchPreset() {
        this.cancelRequest("saveSearchPreset");
        let formReq_url: string = "/api/search_preset/save";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveSearchPreset"] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdls["saveSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveSearchPreset"].onReadyStateFunction = this.onSaveSearchPreset;
        this.XHRHdls["saveSearchPreset"].execute();
    }

    private onSaveSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    // refactor this into a helper class.
    protected saveFavoriteSearchPreset(params: { presetId: number; searchPresetType: string }): void {
        this.cancelRequest("saveFavoriteSearchPreset");
        let formReq_url: string = "/api/search_preset/favorite/save/";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(params));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveFavoriteSearchPreset"] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdls["saveFavoriteSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveFavoriteSearchPreset"].onReadyStateFunction = this.onSaveFavoriteSearchPreset;
        this.XHRHdls["saveFavoriteSearchPreset"].execute();
    }

    private onSaveFavoriteSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected deleteSearchPreset(presetId: number): void {
        this.cancelRequest("deleteSearchPreset");
        let usrReq_url: string = "/api/search_preset/delete/" + presetId + "/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["deleteSearchPreset"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["deleteSearchPreset"].onReadyStateFunction = this.onDeleteSearchPreset;
        this.XHRHdls["deleteSearchPreset"].execute();
    }

    protected onDeleteSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) this.XHRHdl.cancelAndReset();
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls !== undefined && this.XHRHdls[requestName] !== undefined) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    protected setDefaultStatusFilters() { }

    // this can also likely be refactored into a helper class
    protected getTagsSuggestion(keyword, idElement) {
        this.XHRHdlCaller = idElement;
        this.cancelRequest("getTagsSuggestion");        
        let subViewModel = { filter: { keyword: keyword }, idElement: idElement };
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getTagsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getTagsSuggestion"].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls["getTagsSuggestion"].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    // let x = responseParsed.data.idElement;
                    if(obj.XHRHdlCaller === "filterTag"){
                        obj.listTemplate.setTagFilter(responseParsed.data.tags,obj.XHRHdlCaller);
                    }else{

                        obj.listTemplate.setTagFilter(responseParsed.data.tags);
                    }
                }
            });
        };
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    public assignTagsToSelectedImages(mode: string, images: Array<any>, tags: Array<any>){
        //this.XHRHdlCaller = idElement;
        this.cancelRequest("assignTagsToSelectedImages");
        this.loadingIn(this.listTemplate.builtTemplate);
        let subViewModel = { images: images, tags: tags, mode: mode };
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/images/tags/save/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["assignTagsToSelectedImages"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["assignTagsToSelectedImages"].onReadyStateFunction = this.onGetBulkTagAssignReturn;
        this.XHRHdls["assignTagsToSelectedImages"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["assignTagsToSelectedImages"].execute();
    }
    
    protected onGetBulkTagAssignReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed) {
                    obj.listTemplate.onClickCancel();
                    obj.getData();
                    obj.listTemplate.getTemplateViewModel().toggleAll(false);
                }
            });
            obj.loadingOut(obj.listTemplate.builtTemplate);
        };
    }

    public importEverettImages(){
        this.cancelRequest("importEverettImages");
        this.loadingIn(this.listTemplate.builtTemplate);
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/images/everett/import/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["importEverettImages"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["importEverettImages"].onReadyStateFunction = this.onImportEverettImagesReturn;
        this.XHRHdls["importEverettImages"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["importEverettImages"].execute();
    }

    protected onImportEverettImagesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed) {
                    //obj.getData();
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_SUCCESS,
                        responseParsed.message,
                    );
                    obj.listTemplate.tagFilter.setTagObjs([{id: 3549304, name: "Everett Collection"}]);
                }
                obj.filterList();
            });
            obj.loadingOut(obj.listTemplate.builtTemplate);
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/images.ts